interface IProps {
    pin: string;
}

const PinIndicator = ({ pin }: IProps) => {
    return (
        <div className="pin-dots">
            {[...Array(6)].map((_, index) => (
                <div
                    key={index}
                    className={`pin-dot ${index < pin.length ? 'active' : ''}`}
                ></div>
            ))}
        </div>
    );
}

export default PinIndicator;